import * as React from "react";
import { BarChart } from "@mui/x-charts/BarChart";
import axiosConfig from "../services/axiosConfig";
import setHeader from "./Functions/setHeader";

const valueFormatter = (value) => `${value} Orders`;

const chartSetting = {
    yAxis: [
        {
            label: "Orders",
            width: 60,
        },
    ],
    series: [{ dataKey: "orders", label: "Monthly Orders", valueFormatter }],
    height: 300,
    margin: { left: 0 },
};

export default function OrdersChart() {
    const [dataset, setDataset] = React.useState([]);
    const [monthlyData, setMonthlyData] = React.useState({});
    const [selectedYear, setSelectedYear] = React.useState(new Date().getFullYear());
    const [availableYears, setAvailableYears] = React.useState([]);

    // Fetch orders data
    React.useEffect(() => {
        fetchOrdersData();
    }, []);

    // Update chart when year changes
    React.useEffect(() => {
        if (monthlyData[selectedYear]) {
            setDataset(monthlyData[selectedYear]);
        }
    }, [selectedYear, monthlyData]);

    const fetchOrdersData = async () => {
        try {
            const res = await axiosConfig.get("orders-graph-report", setHeader());
            const responseData = res.data.data;

            // Set available years (convert strings to numbers and sort descending)
            const years = responseData.availableYears
                .map(year => parseInt(year))
                .sort((a, b) => b - a);
            
            setAvailableYears(years);

            // Set monthly data
            const monthlyDataByYear = {};
            Object.keys(responseData.monthlyData).forEach(year => {
                monthlyDataByYear[parseInt(year)] = responseData.monthlyData[year];
            });
            
            setMonthlyData(monthlyDataByYear);

            // Set default to latest year
            if (years.length > 0) {
                setSelectedYear(years[0]);
            }
        } catch (error) {
            console.error("Error fetching orders data:", error);
        }
    };

    return (
        <div style={{ width: "100%" }}>
            {/* Year selector */}
            <select
                className="form-select mb-3"
                value={selectedYear}
                onChange={(e) => setSelectedYear(Number(e.target.value))}
                style={{
                    padding: "8px 12px",
                    fontSize: "14px",
                    borderRadius: "6px",
                    border: "1px solid #ced4da",
                    backgroundColor: "#fff",
                    color: "#495057",
                    transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
                    minWidth: "120px",
                    cursor: "pointer",
                    width: "150px",
                    margin: '10px'
                }}
                onFocus={(e) => {
                    e.target.style.borderColor = "#80bdff";
                    e.target.style.boxShadow = "0 0 0 0.2rem rgba(0, 123, 255, 0.25)";
                }}
                onBlur={(e) => {
                    e.target.style.borderColor = "#ced4da";
                    e.target.style.boxShadow = "none";
                }}
            >
                {availableYears.map((year) => (
                    <option key={year} value={year}>
                        Year {year}
                    </option>
                ))}
            </select>

            {/* Chart */}
            {dataset.length > 0 ? (
                <BarChart
                    dataset={dataset}
                    xAxis={[{ dataKey: "month", tickPlacement: "middle", tickLabelPlacement: "middle" }]}
                    {...chartSetting}
                />
            ) : (
                <div style={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    height: '300px',
                    color: '#666'
                }}>
                    Loading chart data...
                </div>
            )}
        </div>
    );
}